import React from "react";
import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from "@mui/material";
import { XMarkIcon } from "@heroicons/react/24/outline";
import CollectionReview from "./CollectionReview";

/**
 * The collection review in a dialog, opened from a collection in the sidebar.
 *
 * Mounted lazily: the review makes a request as soon as it renders, and a sidebar full of
 * collections would otherwise fire one per collection on every page load.
 */
const CollectionReviewModal = ({ open, onClose, collectionId, collectionName }) => {
  const userDetails = localStorage.getItem("userDetail");
  const companyId = userDetails ? JSON.parse(userDetails)?.companyid : null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth scroll="paper">
      <DialogTitle
        sx={{
          fontSize: 16,
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          gap: 1,
          borderBottom: "1px solid #e5e7eb",
          py: 1.5,
        }}
      >
        <span style={{ flexShrink: 0 }}>Test case review</span>
        {collectionName && (
          <Tooltip title={collectionName} arrow>
            <span
              style={{
                fontSize: 13,
                fontWeight: 400,
                color: "#6b7280",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                minWidth: 0,
              }}
            >
              {collectionName}
            </span>
          </Tooltip>
        )}
        <IconButton onClick={onClose} size="small" sx={{ ml: "auto", flexShrink: 0 }} aria-label="Close review">
          <XMarkIcon className="h-5 w-5" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ bgcolor: "#f9fafb", p: 2.5 }}>
        {open && <CollectionReview collectionId={collectionId} companyId={companyId} />}
      </DialogContent>
    </Dialog>
  );
};

export default CollectionReviewModal;
